import { Alert } from 'components/Alert/Alert';
import { useTranslations } from 'utils/translations/useTranslations';
import { Info } from '../../../../../Alert/Info/Info';

const NoOptionsIndia = () => {
  const i18n = useTranslations();
  return (
    <Alert type="info-no-border">
      <Info.FilledIcon height="14" width="14" className="marginRight-sm" />
      <strong>{i18n.t('paymentOptions.noOffers.title')}</strong>{' '}
      <div className="mt-[10px] ml-[22px]">
        {i18n.t('paymentOptions.noOffers.india_description')}
      </div>
    </Alert>
  );
};

export { NoOptionsIndia };
